<template>
  <div class="min-h-screen w-full bg-primary">
    <div class="flex justify-center w-full p-8">
      <div class="max-w-2xl w-full bg-white rounded-2xl p-6 shadow-xl">
        <h1 class="text-2xl font-bold text-gray-800 mb-6">
          Projects
        </h1>

        <div class="relative mb-6">
          <TbInput
            v-model="search"
            placeholder="Search projects..."
            class="
              w-full
              pl-10
              pr-4
              py-3
              rounded-lg
              border
              border-gray-200
              focus:border-primary-500
              focus:ring-2
              focus:ring-primary-200
              transition-all
              duration-200
            "
          />
        </div>

        <div class="overflow-y-auto max-h-[60vh] rounded-lg border border-gray-200 bg-gray-50">
          <div
            v-for="project in filteredProjects"
            :key="project.id"
            class="w-full"
          >
            <router-link
              :to="{ name: Pages.dashboardHome, params: { projectId: project.id} }"
              class="flex items-center p-4 hover:bg-white transition-colors duration-200 border-b border-gray-100 last:border-b-0"
            >
              <div class="flex-1">
                <h3 class="text-lg font-bold text-gray-800">
                  {{ project.name }}
                </h3>
                <p class="text-sm text-gray-500">
                  Project ID: {{ project.id }}
                </p>
              </div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-5 w-5 text-gray-400"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </router-link>
          </div>

          <div
            v-if="filteredProjects.length === 0"
            class="p-8 text-center text-gray-500"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-12 w-12 mx-auto mb-4 text-gray-400"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
            <p>No projects found</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  inject, Ref, computed, ref,
} from 'vue';
import { AppState } from '@/pages/app/api/get_app_state';
import { TbInput } from '@/components/tasty_bistro';
import { Pages } from '../../../router/index';

const search = ref('');
const appState = inject<Ref<AppState>>('state') as Ref<AppState>;

const filteredProjects = computed(() => {
  const { projects } = appState.value;
  const searchTerm = search.value.toLowerCase();

  return projects.filter((project) => {
    const projectId = project.id;
    const name = project.name || 'Undefined';
    return !searchTerm
      || name.toLowerCase().includes(searchTerm)
      || projectId.toLowerCase().includes(searchTerm);
  });
});
</script>
